module.exports = __webpack_public_path__ + "media/images/redesign-images/shared/best-sellers/best-sellers-02-530ef64ef225b4c7bfd59199f1d36307.jpg";